import { render, staticRenderFns } from "./ResponseDetails.vue?vue&type=template&id=0df1d1f9&scoped=true&"
import script from "./ResponseDetails.vue?vue&type=script&lang=js&"
export * from "./ResponseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ResponseDetails.vue?vue&type=style&index=0&id=0df1d1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1d1f9",
  null
  
)

export default component.exports